window.onpopstate = function() {
    location.reload();
};